/**
 * INKASA landing page — small vanilla-JS enhancements.
 * - Sticky mobile CTA: appears after the hero, hides once the final CTA is reached.
 * - Very light hero parallax (transform only, rAF-throttled).
 * No external libraries. Bails out entirely on prefers-reduced-motion.
 */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.inkasa-lp').forEach((root) => {
    initStickyCta(root);
    if (!reduceMotion) initHeroParallax(root);
  });

  function initStickyCta(root) {
   const bar = document.querySelector('.inkasa-lp-sticky');
    const hero = root.querySelector('.inkasa-lp__hero');
    const finalSection = root.querySelector('.inkasa-lp__final');
    if (!bar || !hero) return;

    let pastHero = false;
    let inFinal = false;

    const updateVisibility = () => {
      bar.classList.toggle('is-visible', pastHero && !inFinal);
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          });
          updateVisibility();
        },
        { threshold: 0 }
      ).observe(hero);

      if (finalSection) {
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              inFinal = entry.isIntersecting;
            });
            updateVisibility();
          },
          { threshold: 0.35 }
        ).observe(finalSection);
      }
    }
  }

  function initHeroParallax(root) {
    const media = root.querySelector('.inkasa-lp__hero-media img');
    const hero = root.querySelector('.inkasa-lp__hero');
    if (!media || !hero) return;

    let ticking = false;

    const update = () => {
      ticking = false;
      const rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const offset = rect.top * -0.06;
      media.style.transform = `translateY(${offset}px) scale(1.08)`;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }
})();